import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef } from '@mui/x-data-grid-pro';
import { IConfigComponent } from '@ts/ui-models';
import { generateGlobalColumns, generateBasicColumn, IDataGridConfig, TInheritedProps } from '@ts/storybook';

interface IAppProfilesProps {
  configComponent?: IConfigComponent;
  inheritedProps?: TInheritedProps<false>;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'appProfiles',
  aclId: 'taProfile',
  entity: 'appProfile',
  fetchURL: '/api/appProfiles',
  crudURL: '/api/appProfile',
};

const AppProfiless = (props: IAppProfilesProps) => {
  const { configComponent = defaultConfigComponent } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = useMemo((): GridColDef<any>[] => {
    const mixProps = { ...props, configComponent };
    const globalCells = generateGlobalColumns(mixProps);
    return [globalCells.id(), globalCells.name(), generateBasicColumn({ field: 'notes' }, { field: 'notes' })];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      //Extra data
      inheritedProps={props.inheritedProps}
    />
  );
};

export default AppProfiless;
